<template>
  <div>
    <div class="banner">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082502432395.jpg"></el-image>
      <div class="cover">
        <h1>集团介绍</h1>
        <div class="subtitle">关于诗董</div>
      </div>
    </div>
    <div class="box1">
      <el-row>
        <el-col :span="12">
          <div class="bb">
            <div>
              <el-image src="/img/6666.jpg"></el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="cc">
            <h1>诗董集团</h1>
            <p class="intro-text">
              诗董橡胶股份有限公司(Sri TrangAgro-Industry Plc.)1987年成立于泰国合艾，经过三十余年的稳健发展已成长为全球知名的天然橡胶产业链集成企业，并在泰国证券交易所(SET)和新加坡交易所(SGX)实现双边上市。
            </p>
            <p class="intro-text">
              诗董业务覆盖橡胶园种植、初级橡胶原料加工、终端橡胶产品制造、国际橡胶贸易、配套及物流服务等领域，打造了完善的产业链一体化布局。
            </p>
            <p class="intro-text">
              诗董在泰国19个省府运营近7200公顷橡胶园。
            </p>
            <p class="intro-text">
              橡胶加工业务板块，公司在泰国、印度尼西亚布局34间加工厂，泰国和印尼是全球主要的天然橡胶生产国，缅甸也具备可观的天然橡胶生产潜力。
            </p>
            <p class="intro-text">
              诗董可生产标胶(TSR)、烟片胶(RSS)和浓缩乳胶等全系列天然橡胶产品，年总生产能力达317.8万吨，凭借高效、诚信、专业的产品与服务，为全球各大轮胎企业、橡胶制品企业稳定供应高品质绿色原材料。
            </p>
            <p class="intro-text">
              终端橡胶制品领域，旗下子公司诗董手套(泰国)公共有限公司是泰国颇具规模的手套生产企业，也是全球知名的手套生产企业之一。
            </p>
            <p class="intro-text">
              该子公司在泰国设有7间工厂，年手套总生产能力达553亿只，可生产乳胶无粉、乳胶有粉和丁腈手套，产品广泛应用于医疗、工业、科研及民用等多个领域。
            </p>
            <p class="intro-text">
              此外，诗董旗下设有多家子公司，为核心业务提供研发、物流、橡胶木加工等全方位运营支持。
            </p>
            <p class="intro-text">
              秉持奋进初心，诗董集团持续巩固天然橡胶和检查手套领域的行业地位，深耕绿色橡胶、健康手套产业积极践行社会责任，助力行业稳健前行。
            </p>
            <div class="btn">
              <a href="https://sritrang.oss-cn-shanghai.aliyuncs.com/file/introduction.zip">下载集团宣传册</a>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="box2">
      <el-image src="/img/b11.jpg"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
@import url("Index.css");
</style>